import { useEffect, useRef, useState } from "react";

import { Image } from "../../AppDataType";
import ImageModal from "../ImageModal/ImageModal";

/* ========================================================================== */

interface Props {
    outsideImages: Image[];
    onAllImagesLoaded: () => void;
    isHidden: boolean;
}

const OutsideFullCard: React.FC<Props> = ({ outsideImages, onAllImagesLoaded, isHidden }) => {
    const [imagesLoaded, setImagesLoaded] = useState(0);

    /* ====== IMAGE MODAL ====== */
    const [isModalImageOpen, setIsModalImageOpen] = useState(false);
    const imgRef = useRef<HTMLImageElement>(null);

    const handleOnImageClick = (src: string, alt: string) => {
        if (imgRef.current) {
            imgRef.current.src = src;
            imgRef.current.alt = alt;
            setIsModalImageOpen(true);
        }
    }

    /* ========================= */

    useEffect(() => {
        if (imagesLoaded === outsideImages.length && isHidden) {
            setImagesLoaded(0);
            onAllImagesLoaded();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [imagesLoaded, outsideImages.length, isHidden]);


    const handleImageLoad = () => {
        setImagesLoaded(prev => prev + 1)
    }

    return (
        <section aria-label="outside-photos"
                 className={`container mx-auto bg-first-solid rounded-xl p-4 mb-8
                          ${ isHidden ? "hidden" : "flex flex-col"}`}>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-4 gap-y-4">
            {
                outsideImages.map((image, index) => (
                    <figure key={index}
                            className={`border-2 border-second-solid rounded-xl overflow-hidden
                                     ${ index % 3 === 0 ? "lg:col-span-full h-[200px] lg:object-center object-bottom lg:h-full" : ""}`}>
                        <img src={image.src}
                             alt={image.alt}
                             className="size-full object-cover cursor-pointer 
                                        transition-transform duration-500 ease-in-out
                                        hover:scale-105"
                             onLoad={handleImageLoad}
                             onClick={() => handleOnImageClick(image.src, image.alt)}/>
                    </figure>
                ))
            }
            </div>

            <ImageModal open={isModalImageOpen}
                        onClose={() => setIsModalImageOpen(false)}>
                <img ref={imgRef} 
                     src={outsideImages[0]?.src}
                     alt={outsideImages[0]?.alt}/>
            </ImageModal>
        </section>
    )
}

export default OutsideFullCard;
